export default {"src":"/_next/static/media/banner.4d8e45b3.svg","height":1200,"width":1600,"blurWidth":0,"blurHeight":0};